import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { sortBy } from 'lodash';
import { getExtraRoleList, getPositions, getAllRoles } from './api';
import { ILoadedProps, IProps } from './interface';

export const path = `/extra-role/list/`;

const PageExtraRolesList: React.FC<IProps> = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      positions: getPositions,
      extraRoleList: getExtraRoleList,
      allRoles: getAllRoles,
    },
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}) {
      const Page: any = loaded.page.default;

      return (
        <Page
          {...loadedProps}
          allRoles={sortBy(
            loaded.allRoles.map((role) => ({ value: role, label: role })),
            'label',
          )}
          extraRoleList={loaded.extraRoleList}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageExtraRolesList;
